import server from "./server";
import Vue from "vue";
let mod = {
    db: new Vue({
        data() {
            return{
                db: {}
            };
        }
    }),
    refresh(name, id, cb) {
        return new Promise((cb) => {
            if (this.fn[name]) {
                this.defFnR(name, id, cb);
            } else {
                cb();
            }
        });
    },
    wait(name, cb) {
        var p = new Promise((cb) => {
            let loop = () => {
                if (this.db.db[name] && !this.db.db[name].wait) {
                    cb();
                } else {
                    setTimeout(() => {
                        loop();
                    }, 10);
                }
            };
            loop();
        });
        p.then(() => {
            if (cb) {
                cb();
            }
        });
        return p;

    },
    getSelection(name, id, arr) {
        if (!arr) {
            arr = id;
            id = null;
        }
        var n = id ? name + "." + id : name;
        if (this.db.db[n]) {
            var out = [];
            for (var i in this.db.db[n].items) {
                for (var j in arr) {
                    if (this.db.db[n].items[i].val == arr[j]) {
                        out.push(this.db.db[n].items[i]);
                    }
                }
            }
            return out;
        }
        return arr;
    },
    getOneSelection(name, id, obj) {
        if (!obj) {
            obj = id;
            id = null;
        }
        var sel = this.getSelection(name, id, [obj]);
        if (sel.length >= 1) {
            return sel[0];
        }
        return null;
    },
    get(name, id) {
        return new Promise((cb) => {
            if (this.fn[name]) {
                this.defFn(name, id, cb);
            } else {
                cb();
            }
        });
    },
    getObj(name, id) {
        if (this.fn[name]) {
            return this.defFn(name, id, function () {}, true);
        }
        throw "Selection not defined !!";
    },
    defFn(name, id, cb, retObj) {
        var n = id ? name + "." + id : name;
        var self = this;
        if (self.db.db[n]) {
            if (retObj) {
                cb(self.db.db[n]);
            } else {
                cb(self.db.db[n].items);
            }
        } else {
            Vue.set(self.db.db, n, {items: []});
            self.db.db[n].wait = true;
            this.fn[name](id, function (d) {
                self.db.db[n].wait = false;
                Vue.set(self.db.db[n], "items", d);
                if (retObj) {
                    cb(self.db.db[n]);
                } else {
                    cb(self.db.db[n].items);
                }
            });
        }
        return self.db.db[n];
    },
    defFnR(name, id, cb, retObj) {
        var n = id ? name + "." + id : name;
        var self = this;
        if (!self.db.db[n]) {
            Vue.set(self.db.db, n, {items: []});
        }
        self.db.db[n].wait = true;
        this.fn[name](id, function (d) {
            self.db.db[n].wait = false;
            Vue.set(self.db.db[n], "items", d);
            if (retObj) {
                cb(self.db.db[n]);
            } else {
                cb(self.db.db[n].items);
            }

        });
        return self.db.db[n];
    },
    fn: {
        roles(id, cb) {
            server.post("api/user/get", {action: "roles", id: "all"}).then((r) => {
                cb(r.data.models);
            });
        },
        questionary_types(id, cb) {
            server.post("api/course/questionary/get", {action: "types", id: "all"}).then((r) => {
                cb(r.data.models);
            });
        },
        langs(id, cb) {
            server.post("api/general/get", {action: "langs", id: "all"}).then((r) => {
                cb(r.data.models);
            });
        },
        companies(id, cb) {
            server.post("api/company/get", {action: "company_select", id: "all"}).then((r) => {
                cb(r.data.models);
            });
        },
        email_types(id, cb) {
            server.post("api/email/get", {action: "types", id: "all"}).then((r) => {
                cb(r.data.models);
            });
        },
        emails(id, cb) {
            server.post("api/email/get", {action: "emails_select", id: id}).then((r) => {
                cb(r.data.models);
            });
        }
    }

};

export default mod;





// WEBPACK FOOTER //
// ./src/public_app/api/selects.js